import { IconType, defaultProps } from './types';

/**
 * Icono Search
 */
export const EmptyStar = ({
  className,
  width,
  height,
  color = defaultProps.color,
}: IconType): JSX.Element => (
  <svg
    {...(className ? { className: className } : {})}
    {...(width ? { width: width } : {})}
    {...(height ? { height: height } : {})}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <path
      d="m16 3.236 2.641 8.129.225.69h9.273l-6.914 5.024-.588.428.224.69 2.641 8.13-6.914-5.025-.588-.427-.588.427-6.914 5.024 2.64-8.128.225-.691-.588-.428-6.914-5.023h9.273l.225-.691L16 3.236Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
